import * as React from "react";
import { styled } from "styled-components";
import { useTranslation } from "react-i18next";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
import useWidgetConfiguration from "data-lake/preview/hooks/useWidgetConfiguration";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { Spinner, OverlayTrigger } from "components/common";
import { Checkbox } from "components/bootstrap";
import FieldTypeIcon from "views/components/sidebar/fields/FieldTypeIcon";
const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
const StyledCheckbox = styled(Checkbox)`
  margin: 0;
`;
const TableFieldList = ({ tableId, isExpanded }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const { filterableFields, isLoading } = useFieldTypes({ tableId }, isExpanded);
  const { widget, setWidget } = useWidgetConfiguration();
  const { dataLakeFieldsFetchQuery } = useSelectedDataLake();
  const isCurrentTable = (dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId) === tableId;
  const onFieldSelect = (fieldName) => {
    const isSelected = widget.config.fields.includes(fieldName);
    const newFields = isSelected ? widget.config.fields.remove(fieldName) : widget.config.fields.add(fieldName);
    const newConfig = widget.config.toBuilder().fields(newFields).build();
    setWidget(widget.toBuilder().config(newConfig).build());
  };
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("table_field_list.loading") });
  }
  return /* @__PURE__ */ React.createElement("ul", { style: { padding: 0 } }, filterableFields == null ? void 0 : filterableFields.map((field) => /* @__PURE__ */ React.createElement(ListItem, { key: field.name }, /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "hover",
      placement: "bottom",
      disabled: isCurrentTable,
      overlay: t("table_field_list.overlay")
    },
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      StyledCheckbox,
      {
        id: "skip_tls_verification",
        name: "skip_tls_verification",
        onChange: () => onFieldSelect(field.name),
        disabled: !isCurrentTable,
        checked: isCurrentTable && widget.config.fields.includes(field.name)
      },
      /* @__PURE__ */ React.createElement(FieldTypeIcon, { type: field.type }),
      " ",
      field.name
    ))
  ))));
};
export default TableFieldList;
